export default "__VITE_ASSET__CFm_YDou__"